import "./Home.module.css";
import GatewayNavigation from "@/reusable_sections/Header";
import DonChuyCuidamosALosQueMasQuieres from "./sections/DonChuyCuidamosALosQueMasQuieres";
import OurCommitment from "./sections/OurCommitment";
import PerformanceMetrics from "./sections/PerformanceMetrics";
import PracticalLabModules from "./sections/PracticalLabModules";
import ReadyToLaunchYourKitchenOnline from "./sections/ReadyToLaunchYourKitchenOnline";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <GatewayNavigation />
      <DonChuyCuidamosALosQueMasQuieres />
      <OurCommitment />
      <PerformanceMetrics />
      <PracticalLabModules />
      <ReadyToLaunchYourKitchenOnline />
      <Footer />
    </div>;
}